<router-outlet></router-outlet>
<mat-spinner *ngIf="isLoading" style="position: absolute; top: 50%; left: 50%; margin: -50px 0px 0px -50px; z-index: 1000;"></mat-spinner>